import { render, staticRenderFns } from "./Project_Manage.vue?vue&type=template&id=4c019d95&"
import script from "./Project_Manage.vue?vue&type=script&lang=js&"
export * from "./Project_Manage.vue?vue&type=script&lang=js&"
import style0 from "./Project_Manage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports